export const ExpandableTextDataHooks = {
  Text: 'expandable-text-text',
  Button: 'expandable-text-button',
};
